import React from "react";
import { FolioAbout } from "../app-template/AppContent";
import AboutContent from "./AboutContent";
import ProfilePic from "./img/martin-duggan-profile-pic2020.jpg";

function AboutView() {
	// window.scrollTo(0, 0); // scroll to top of page

	return (
		<section className="about-me">
			<article className="content">
				<h2 className="title">{FolioAbout.linkName}</h2>
				<div className="inner">
					<div className="text-block">
						{AboutContent.aboutMe.paras.map((para) => {
							return <p className="para">{para}</p>;
						})}
					</div>
					<figure className="profile-pic">
						<img src={ProfilePic} alt="Profile of Martin Duggan" />
					</figure>
				</div>
			</article>
		</section>
	);
}

export default AboutView;
